import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_2 = { class: "col-sm-12 col-md-3 d-none d-md-block" }
const _hoisted_3 = { class: "col-sm-12 col-md-9" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex justify-content-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: "/local/templates/travel/img/filter_new_icon.png" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { id: "block-1" }
const _hoisted_10 = { class: "mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filters_block = _resolveComponent("filters-block")!
  const _component_loading_dots = _resolveComponent("loading-dots")!
  const _component_excursions_view = _resolveComponent("excursions-view")!
  const _component_error_view = _resolveComponent("error-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.error && _ctx.cityCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_filters_block, { filters: _ctx.filters }, null, 8, ["filters"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_loading_dots)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h5", null, "Мы нашли " + _toDisplayString(_ctx.filteredExcursions.length) + " предложений", 1),
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showFilters && _ctx.showFilters(...args))),
                      class: "funnel_icon"
                    }, _hoisted_8)
                  ]),
                  _createVNode(_component_excursions_view, { excursions: _ctx.filteredExcursions }, null, 8, ["excursions"])
                ]))
          ])
        ]))
      : (_openBlock(), _createBlock(_component_error_view, {
          key: 1,
          error: _ctx.error
        }, null, 8, ["error"])),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        id: "desctop_f",
        class: _normalizeClass([{active: _ctx.isFilterOpened}, "layout-scrollbar"])
      }, [
        _createElementVNode("div", {
          class: "close_filter",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showFilters && _ctx.showFilters(...args)))
        }),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_filters_block, { filters: _ctx.filters }, null, 8, ["filters"])
        ])
      ], 2)
    ])
  ], 64))
}